import React from 'react';
import { cn } from '@/lib/utils';
import logoNetuno from '@/assets/logo_netuno.png';

interface SiafoLogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  showSubtitle?: boolean;
  className?: string;
  /** Use dark variant (for light backgrounds like auth page) */
  onLight?: boolean;
}

const SiafoLogo: React.FC<SiafoLogoProps> = ({ 
  size = 'md', 
  showText = true,
  showSubtitle = true,
  onLight = false,
  className 
}) => {
  const logoSizes = {
    sm: 'w-14 h-14',
    md: 'w-[72px] h-[72px]',
    lg: 'w-28 h-28'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-3xl'
  };

  const subtitleSizeClasses = {
    sm: 'text-xs',
    md: 'text-xs',
    lg: 'text-sm'
  };

  const letterSpacing = {
    sm: 'tracking-[0.15em]',
    md: 'tracking-[0.2em]',
    lg: 'tracking-[0.25em]'
  };

  const isOnAuthPage = typeof window !== 'undefined' && window.location.pathname === '/auth';
  const useLight = onLight || isOnAuthPage;
  
  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      <img 
        src={logoNetuno} 
        alt="NetUno Logo" 
        className={cn(logoSizes[size], 'object-contain flex-shrink-0')}
      />
      {showText && (
        <div className="animate-fade-in">
          <h1 className={cn(
            'font-bold font-sans leading-tight',
            useLight ? 'text-foreground' : 'text-sidebar-foreground',
            textSizeClasses[size],
            letterSpacing[size]
          )} style={{ color: useLight ? 'hsl(var(--brand))' : undefined }}>
            NetUno
          </h1>
          {showSubtitle && (
            <p className={cn(
              'mt-0.5 leading-snug whitespace-nowrap',
              useLight ? 'text-muted-foreground' : 'text-sidebar-foreground/60',
              subtitleSizeClasses[size]
            )}>
              Menos riscos, melhores decisões, maior previsibilidade
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default SiafoLogo;
